<template>
  <div class="content-wrapper remove_table_shadow">
    <div class="d-flex justify-content-end mb-3">
      <button type="button" class="btn btn-primary" @click.prevent="downloadReport">
        <app-icon name="download" class="mr-1"/>
        {{ $t('download_report') }}
      </button>
    </div>
    <app-table
      :id="tableId"
      :options="options"
      @action="getListAction"
      @getFilteredValues="setReportFilters"
    />


  <certificate-listing-modal
      v-if="showCertificateListingModal"
      :user_id="userId"
      @close-modal="closeFormModal"
  />
</div>
</template>

<script>
import * as actions from "@/app/Config/ApiUrl";
import CoreLibrary from "@/core/helpers/CoreLibrary";
import {TableHelpers} from "@Views/Demo/Tables/mixins/TableHelpers";
import { axiosPost } from "../../../Helpers/AxiosHelper.js";

export default {
  extends: CoreLibrary,
  name: "CertificateUsers",
  mixins: [TableHelpers],
  props: {
    certificate_id: {type: Number, default: null},
  },
  data() {
    return {
      userId: '',
      certificateDetail: {},
      packages: {},
      isAddEditModalActive: false,
      deleteConfirmationModalActive: false,
      deleteLoader: false,
      selectedUrl: "",
      tableId: "company-employees-table",
      rowData: {},
      input: {},
      selectedUserScope: 'internal',
      showCertificateListingModal: false,
      options: {
        name: "CompanyEmployeesTable",
        url: `${actions.USERS}?user_scope=internal`,
        // url: actions.DATATABLE_DATA,
        showHeader: true,
        columns: [
          {
            title: this.$t('user'),
            type: 'media-object',
            key: 'image',
            imgKey: "image",
            mediaTitleKey: 'nameWithCompany',
            mediaSubtitleKey: 'email',
            default: "",
            isVisible: true,
            modifier: (value, row) => {
              return value ? value.path : '';
            }
          },
          {
            title: this.$t("trainings"),
            type: "component",
            key: "training_certificates",
            isVisible: true,
            className: "w-100",
            componentName: "group-of-trainings",
          },
          {
            title: this.$t('status'),
            type: 'custom-html',
            key: 'status',
            isVisible: true,
            modifier: (value) => {
              return `<span class="badge badge-sm badge-pill badge-${value.class}">${value.translated_name}</span>`;
            }
          },
          // {
          //   title: this.$t('action'),
          //   type: 'action',
          //   key: 'invoice',
          //   isVisible: true
          // },
        ],
        actions: [
          {
            title: this.$t("assign_trainings_to_user"),
            icon: "bookmark",
          },
        ],
        filters: [
          {
            title: this.$t('user_type'),
            type: "radio",
            key: "user_scope",
            option: [
              {id: 'internal', value: 'Internal Users'},
              {id: 'external', value: 'External Users'},
            ],
          },
          // {
          //     "title": this.$t('date'),
          //     "type": "range-picker",
          //     "key": "date",
          //     "option": ["today", "thisMonth", "last7Days", "nextYear"]
          // },
          // {
          //     "title": this.$t('age'),
          //     "type": "range-filter",
          //     "key": "age-range",
          //     "maxTitle": this.$t('max_age'),
          //     "minTitle": this.$t('min_age'),
          //     "sign": ""
          // },
          // {
          //     "title": this.$t('status'),
          //     "type": "checkbox",
          //     "key": "status",
          //     "option": [
          //         {id: 'active', value: 'Active'},
          //         {id: 'inactive', value: 'Inactive'},
          //         {id: 'invited', value: 'Invited'},
          //     ],
          // },
          // {
          //     "title": this.$t('gender'),
          //     "type": "radio",
          //     "key": "filter-with-gender",
          //     "option": [
          //         {id: 'male', value: 'Male'},
          //         {id: 'female', value: 'Female'},
          //         {id: 'other', value: 'Other'},
          //     ],
          //     "header": {
          //         "title": this.$t('want_to_filter_your_list'),
          //         "description": this.$t('you_can_filter_your_data_table_which_are_created_based_on_gender'),
          //     },
          // },
          // {
          //     "title": this.$t('search_and_select'),
          //     "type": "drop-down-filter",
          //     "key": "search select",
          //     "option": [],
          // }
        ],
        showFilter: true,
        showSearch: true,
        showCount: true,
        showClearFilter: true,
        paginationType: "pagination",
        responsive: true,
        rowLimit: 10,
        showAction: true,
        orderBy: "desc",
        actionType: "dropdown",
      },
    };
  },
  created() {
    this.options.columns = [...this.options.columns, this.actionObj];
    // this.searchAndSelectFilterOptions()
  },
  mounted() {
    // this.getPackages();
    setTimeout(() => {
      $(
          ".remove_table_shadow .h-100 .datatable .table-responsive "
      ).removeClass("shadow");
    }, 1000);
  },
  methods: {
    closeFormModal(){
      this.showCertificateListingModal = false
    },

    /**
     * for open add edit modal
     */
    openAddEditModal() {
      this.isAddEditModalActive = true;
    },

    /**
     * for close add edit modal
     */
    closeAddEditModal() {
      $("#demo-add-edit-Modal").modal("hide");
      this.isAddEditModalActive = false;
      // this.searchAndSelectFilterOptions()
      this.reSetData();
    },
    closeViewModal() {
      $("#view-detail-Modal").modal("hide");
      this.isViewModalActive = false;
      this.certificateDetail = {};
    },
    getListAction(rowData, actionObj, active) {
      this.rowData = rowData;
      this.$store.commit('updateSharedData', {index: "selectedEmployee", newValue: rowData})
      if (actionObj.title === this.$t("assign_trainings_to_user")) {

        if(this.certificate_id != null) {
          this.assignTraining(rowData.id, this.certificate_id);
        }
        else {
          this.userId = rowData.id;
          this.showCertificateListingModal = true
        }
      }
    },
    downloadReport() {
      window.location.href = `${actions.TRAINING_REPORT}?user_scope=${this.selectedUserScope}`;
    },
    setReportFilters(filters) {
      this.selectedUserScope = filters.user_scope || 'internal';
    },
    assignTraining(user_id, certificate_id) {
      axiosPost(actions.ASSIGN_TRAINING, {userId:user_id, certificateId:certificate_id })
        .then((res) => {
          const message = res.data?.message || res.data;
          const type = res.data?.type || "success";

          if (type === "error") {
            this.$toastr.e(message);
          } else if (type === "applied") {
            this.$toastr.w(message);
          } else {
            this.$toastr.s(message);
          }

          this.$hub.$emit("reload-" + this.tableId);
        })
        .catch((error) => {
          this.$toastr.e(error?.response?.data?.message || error);
        });
      },
  }
};
</script>

<style scoped>
.remove_table_shadow .h-100 .datatable .table-responsive {
  box-shadow: none !important;
}
</style>
  
